var map = {
	"./AnnualInspections-Info-da.png": 34927,
	"./AnnualInspections-Info-en.png": 50191,
	"./AnnualInspections-Info-fi.png": 91597,
	"./AnnualInspections-Info-sv.png": 5453,
	"./Dashboard-Info-da.png": 79029,
	"./Dashboard-Info-en.png": 16217,
	"./Dashboard-Info-fi.png": 56023,
	"./Dashboard-Info-nb.png": 66076,
	"./Dashboard-Info-pl.png": 73932,
	"./Dashboard-Info-sv.png": 1507,
	"./RecordObservation-Info-fi.png": 16832,
	"./ReturnedDevices-Info-da.png": 24351,
	"./ReturnedDevices-Info-en.png": 4863,
	"./ReturnedDevices-Info-fi.png": 97981,
	"./ReturnedDevices-Info-nb.png": 43350,
	"./ReturnedDevices-Info-pl.png": 73510,
	"./ReturnedDevices-Info-sv.png": 93693,
	"./ServicedDevices-Info-da.png": 26549,
	"./ServicedDevices-Info-en.png": 63737,
	"./ServicedDevices-Info-fi.png": 87191,
	"./ServicedDevices-Info-sv.png": 49027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58931;